import { nextTick, watch } from 'vue';

export function useAutoScroll(containerRef, triggers) {
    const scrollToBottom = async () => {
        await nextTick();
        if (containerRef.value) {
            containerRef.value.scrollTop = containerRef.value.scrollHeight;
        }
    };

    for (const trigger of triggers) {
        watch(trigger, scrollToBottom);
    }

    return { scrollToBottom };
}
